import { queryOptions, useQuery } from "@tanstack/react-query";
import type { QueryClient } from "@tanstack/react-query";
import { dashboardApi } from "../api/dashboard";
import type { DashboardSummary } from "../api/dashboard";
import { requireData, yieldToCancellation } from "./http";

export const dashboardQueryKeys = {
  all: ["dashboard"] as const,
  summary: ["dashboard", "summary"] as const,
};

export const dashboardQueryOptions = () =>
  queryOptions({
    queryKey: dashboardQueryKeys.summary,
    queryFn: async ({ signal }): Promise<DashboardSummary> => {
      await yieldToCancellation(signal);
      return requireData(await dashboardApi.get(signal));
    },
    refetchOnReconnect: true,
    refetchOnWindowFocus: true,
    staleTime: 30 * 1000,
  });

export const useDashboard = () => useQuery(dashboardQueryOptions());

export const invalidateDashboard = (queryClient: QueryClient) =>
  queryClient.invalidateQueries({ queryKey: dashboardQueryKeys.all });
